import { render } from "./LinkedinPostEditor.vue?vue&type=template&id=83c1acf4&scoped=true"
import script from "./LinkedinPostEditor.vue?vue&type=script&lang=js"
export * from "./LinkedinPostEditor.vue?vue&type=script&lang=js"

import "./LinkedinPostEditor.vue?vue&type=style&index=0&id=83c1acf4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83c1acf4"]])

export default __exports__